export type { TextPresetProps, TextProps, TextSlots, TextState } from './components/Text/index';
export {
  Text,
  renderText_unstable,
  textClassNames,
  useTextStyles_unstable,
  useText_unstable,
} from './components/Text/index';
